<template>
<div class="chapter">
<div class="inner_page">
<p class="legal-txtt">Publisher: Amy Marson</p>
<p class="legal-txt">Creative Director: Gailen Runge</p>
<p class="legal-txt">Acquisitions Editor: Roxane Cerda</p>
<p class="legal-txt">Managing Editor: Liz Aneloski</p>
<p class="legal-txt">Editor: Kathryn Patterson</p>
<p class="legal-txt">Technical Editor: Julie Waldman</p>
<p class="legal-txt">Cover/Book Designer: April Mostek</p>
<p class="legal-txt">Production Coordinator: Zinnia Heinzmann</p>
<p class="legal-txt">Production Editor: Jennifer Warren</p>
<p class="legal-txt">Illustrator: Aliza Shalit</p>
<p class="legal-txt">Photo Assistant: Mai Yong Vang</p>
<p class="legal-txt">Style photography by Lucy Glover and instructional photography by Mai Yong Vang of C&amp;T Publishing, Inc., unless otherwise noted</p>
<p class="legal-txt">Published by C&amp;T Publishing, Inc., P.O. Box 1456, Lafayette, CA 94549</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_copyright.vue?3b5912ad